import { render, staticRenderFns } from "./productThird.vue?vue&type=template&id=ed044b9c&scoped=true"
import script from "./productThird.vue?vue&type=script&lang=js"
export * from "./productThird.vue?vue&type=script&lang=js"
import style0 from "./productThird.vue?vue&type=style&index=0&id=ed044b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed044b9c",
  null
  
)

export default component.exports